export const BANNER_IMAGE_CONFIG = {
  dimensions: {
    'https://api.outletin.sk/files/LiZjeEKCYTETn8Rlwe1AArNNzvqvzeSrqPvjoaRa.png': {
      width: 684,
      height: 330,
    },
  },
} as const;
